export const mapToAutocompleteItems = ({ items, valueKey, nameKey }) =>
  items.map((item) => ({
    value: item[valueKey],
    name: item[nameKey],
  }));
